<template>
  <tr>
    <td
      v-if="selectable"
      @click="toggleSelected"
    >
      <input
        :id="`membership-${membership.uuid}`"
        :checked="selected"
        :name="`membership-${membership.uuid}`"
        type="checkbox"
      >
      <label
        :for="`membership-${membership.uuid}`"
        class="checkbox pb-2"
        style="padding-left: 0 !important;"
      />
    </td>
    <td>
      <a
        href="#"
        @click.prevent="visitProfile"
        v-text="firstName"
      />
    </td>
    <td>
      <a
        href="#"
        @click.prevent="visitProfile"
        v-text="lastName"
      />
    </td>
    <td>
      <a
        href="#"
        @click.prevent="visitProfile"
        v-text="email"
      />
    </td>
    <td>
      <div
        v-if="membershipGroupsPreview.length"
        class="flex flex-wrap items-center"
      >
        <ul class="tags max-w-xs ">
          <li
            v-for="(group, index) in membershipGroupsPreview"
            :key="`group-${index}`"
            v-text="group.attributes.title"
          />
        </ul>
        <a
          v-if="hasMoreGroupsThanDisplayed"
          class="ml-auto uppercase"
          href="#"
          @click.prevent="visitProfile"
          v-text="'View all'"
        />
      </div>
      <span v-else>&ndash;</span>
    </td>
    <td>
      <div
        class="tag"
        v-text="membershipStatus"
      />
    </td>
    <td v-if="!selectable">
      <a
        href="#"
        @click.prevent="visitEditProfile"
        v-text="'Edit'"
      />
    </td>
  </tr>
</template>

<script type="text/babel">
export default {
  name: 'MembershipRow',
  props: {
    membership: {
      type: Object,
      required: true,
    },
    selectable: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSelected: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      selected: this.isSelected,
    }
  },
  computed: {
    membershipStatus() {
      return this.membership.attributes.deactivated
        ? 'Deactivated'
        : _.upperFirst(this.membership.attributes.status)
    },
    hasMoreGroupsThanDisplayed() {
      return this.membershipGroups.length > this.membershipGroupsPreview.length
    },
    membershipGroupsPreview() {
      return this.membershipGroups.slice(0, 3)
    },
    membershipGroups() {
      return this.$store.getters.membershipGroups
    },
    editLink() {
      return this.$urlGenerator.active(`members/${this.membership.uuid}/edit`)
    },
    email() {
      return this.membership.attributes.email
    },
    firstName() {
      return this.membership.attributes.first_name
    },
    lastName() {
      return this.membership.attributes.last_name
    },
    fullName() {
      return this.membership.attributes.full_name
    },
    avatarUrl() {
      return this.membership.attributes.small_avatar_url
    },
  },
  methods: {
    visitProfile() {
      window.location = this.$urlGenerator.active(`members/${this.membership.uuid}`)
    },
    visitEditProfile() {
      window.location = this.$urlGenerator.active(`members/${this.membership.uuid}/edit`)
    },
    toggleSelected() {
      this.selected = !this.selected

      this.$emit(this.selected ? 'membershipSelected' : 'membershipRemoved', {
        membership: this.membership,
      })
    },
  },
}
</script>
